module.exports = __webpack_public_path__ + "static/media/rs_china.9da015e6.png";